exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MemberCreate {\n  float: left;\n  width: calc(33.333333% - 24px);\n  border-radius: 3px;\n  cursor: pointer;\n  border: 1px solid rgba(255, 155, 30, 0.3);\n  padding: 24px;\n  position: relative;\n  text-transform: uppercase;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: #ff9b1e;\n  text-align: center;\n  background: rgba(255, 155, 30, 0.04);\n  margin: 0 12px;\n  height: 198px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: color 0.2s, border-color 0.2s; }\n  .MemberCreate:hover {\n    color: #ea8200;\n    border-color: rgba(255, 155, 30, 0.6); }\n", ""]);

// exports
